// assets/nd-xlsx-exporter.js — XLSX export (v4.3J-ABS-BONLY-FITCENTER-FLOATCOL+TRIMNAMEONLY+HEADER+IMG_SCALE+QUOTE_SYNC)
// 只用「B 欄」當圖片區；先全域縮放(IMG_GLOBAL_SCALE) → 再水平 FIT 到 B 欄 → 再依 Door Size 後第 2~3 列開始疊圖
// ★ 只修剪 Option **Name** 的 " - xxxx"；Option **Value** 完整保留
// ★ v4.3J-FactorPerUnit: Unit/Line/Estimated total 改成 per-unit rounding（單價*factor→round(cents)→*qty→加總）
(function () {
  if (window.__ND_XLSX_EXPORT_V43J_ABS_BONLY_FITCENTER_FLOATCOL_SCALE_TRIMNAMEONLY__) return;
  window.__ND_XLSX_EXPORT_V43J_ABS_BONLY_FITCENTER_FLOATCOL_SCALE_TRIMNAMEONLY__ = true;
  console.info('[ND XLSX] v4.3J ABS B-only FIT Center + IMG_GLOBAL_SCALE + TRIM NAME ONLY + QUOTE_SYNC loaded');

// ===== GLOBAL SAFETY: parseAddon alias =====
if (typeof window.parseAddon !== 'function') {
  window.parseAddon = function (raw) {
    if (!raw) return { clean: '', add: 0 };
    let s = String(raw).trim(), m, total = 0;
    const re = /\(\s*\+\s*\$?\s*([0-9,]+(?:\.\d{1,2})?)\s*\)/g;
    while ((m = re.exec(s)) !== null) {
      total += parseFloat(m[1].replace(/,/g, '')) || 0;
    }
    s = s.replace(re, '').replace(/\s{2,}/g, ' ').trim();
    return { clean: s, add: total };
  };
}


  /* ---------------- Global Image Scale ---------------- */
  const IMG_GLOBAL_SCALE = 1.2;   // 可改 0.6~2.0

  /* ---------------- Cloud ---------------- */
  const CLOUD_UPLOAD_ENABLED = true;
  const CLOUD_ENDPOINT = 'https://nd-onedrive-uploader-2.vercel.app/apps/nd-upload/upload';
  const ROOT_FOLDER = 'QuoteNeuma';

  /* ---------------- Basics ---------------- */
  const COMPANY = 'Neuma Doors';
  const pad2 = n => String(n).padStart(2, '0');
  const fmtMDY = (d = new Date()) => `${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}-${d.getFullYear()}`;

  // ★ 會計格式：三位一逗點，兩位小數
  const formatDollar = (d) => {
    const n = Number(d || 0);
    return n.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  // money：接「分」(cents)，內部轉成「元」再加三位一逗點
  const money = (c) => formatDollar(Number(c || 0) / 100);

  const norm = s => String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();

  // ★ 只裁掉「空白-橫線-空白」之後的字（只用在 Name）
  const trimDash = (s) => s == null ? s : String(s).replace(/\s-\s.*$/, '').trim();
// ✅ NEW: only trim trailing UUID in Option Value (optional)
function trimUuidTail(s){
  if (s == null) return s;
  const str = String(s).trim();
  return str.replace(
    /\s-\s[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\s*$/i,
    ''
  ).trim();
}

function buildDoorTypeCategoryMapForNoGlass() {
  const out = {};
  const map = window.NO_GLASS_DEDUCTION_MAP || {};

  Object.keys(map).forEach(category => {
    const categoryMap = map[category] || {};
    Object.keys(categoryMap).forEach(doorType => {
      out[doorType] = category;
    });
  });

  return out;
}

function getCategoryByDoorTypeForNoGlass(doorType) {
  return buildDoorTypeCategoryMapForNoGlass()[doorType] || '';
}

function normalizePanelTypeForNoGlass(raw) {
  const text = String(raw || '').toLowerCase().trim();
  if (/3\s*\/\s*4\s*lite|3\/4\s*lite|3\s*4\s*lite|three\s*quarter\s*lite/.test(text)) {
    return 'three_quarter_lite';
  }
  if (/full\s*view|full\s*lite/.test(text)) {
    return 'full_lite';
  }
  return '';
}

function normalizeDoorSizeForNoGlass(raw) {
  const m = String(raw || '').match(/\b\d{4,6}\b/);
  return m ? m[0] : '';
}

function normalizeDoorTypeForNoGlass(raw) {
  const text = String(raw || '').toLowerCase().trim();

  // 先支援直接 doorType 值
  if (getCategoryByDoorTypeForNoGlass(text)) return text;

  // hinged
  if (/single[\s_-]*hinged/.test(text)) return 'single_hinged';
  if (/double[\s_-]*hinged/.test(text)) return 'double_hinged';
  if (/center[\s_-]*hinged/.test(text)) return 'center_hinged';
  if (/vented[\s_-]*sidelight|venting[\s_-]*sidelight/.test(text)) return 'vented_sidelight';

  // new hinged
  if (/folding\s*door|folding[\s_-]*door|^folding$/.test(text)) return 'folding';

  // gliding
  if (/gliding\s*door\s*-\s*2\s*panels|gliding[\s_-]*2[\s_-]*panel/.test(text)) return 'gliding_2_panel';
  if (/gliding\s*door\s*-\s*3\s*panels|gliding[\s_-]*3[\s_-]*panel/.test(text)) return 'gliding_3_panel';
  if (/gliding\s*door\s*-\s*4\s*panels|gliding[\s_-]*4[\s_-]*panel/.test(text)) return 'gliding_4_panel';

  // new gliding
  if (
    /bypass\s*gliding\s*door|bypass[\s_-]*gliding[\s_-]*door|gliding[\s_-]*bypass|bypass[\s_-]*gliding/.test(text)
  ) return 'gliding_bypass';

  // fixed
  if (/fixed\s*\(?\s*gliding\s*\)?\s*-\s*1\s*panel/.test(text)) return 'gliding_one_panel';
  if (/fixed\s*-\s*1\s*panel/.test(text)) return 'hinged_one_panel';
  if (/fixed\s*-\s*2\s*panels/.test(text)) return 'hinged_two_panel';
  if (/fixed\s*-\s*3\s*panels/.test(text)) return 'hinged_three_panel';

  return '';
}

function getTitleTextFromRowForNoGlass(tr) {
  if (!tr) return '';
  return (
    tr.querySelector('.cart-item__name')?.textContent ||
    tr.querySelector('.cart-item__details a')?.textContent ||
    tr.querySelector('.cart-item__details')?.textContent ||
    ''
  ).trim();
}

function getNoGlassDeductionCentsFromPairs(pairs, tr) {
  try {
    const map = window.NO_GLASS_DEDUCTION_MAP || {};

    let size = '';
    let panelType = '';
    let glassValue = '';
    let doorType = '';

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForNoGlass(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForNoGlass(vv);
      }

      if (!glassValue && /glass\s*option/i.test(kk)) {
        glassValue = vv;
      }

      if (!doorType && /door\s*type/i.test(kk)) {
        doorType = normalizeDoorTypeForNoGlass(vv);
      }
    });

    if (!doorType) {
      doorType = normalizeDoorTypeForNoGlass(getTitleTextFromRowForNoGlass(tr));
    }

    const category = getCategoryByDoorTypeForNoGlass(doorType);

    if (!/no\s*glass/i.test(String(glassValue || ''))) return 0;
    if (!category || !doorType || !size || !panelType) return 0;

    const dollars = Number(
      map?.[category]?.[doorType]?.[size]?.[panelType] || 0
    );

    if (window.NO_GLASS_DEBUG_MODE) {
      console.log('[ND XLSX][NoGlass]', {
        title: getTitleTextFromRowForNoGlass(tr),
        category,
        doorType,
        size,
        panelType,
        glassValue,
        dollars
      });
    }

    return Math.round(dollars * 100);
  } catch (e) {
    console.warn('[ND XLSX] no-glass deduction parse failed', e);
    return 0;
  }
}

function getUnitDimensionFromPairs(pairs, tr, item) {
  try {
    const map = window.UNIT_DIMENSION_MAP || {};

    let size = '';
    let panelType = '';
    let swing = '';
    let doorType = '';

    (pairs || []).forEach(([k, v]) => {
      const kk = String(k || '');
      const vv = String(v || '');

      if (!size && /door\s*size/i.test(kk)) {
        size = normalizeDoorSizeForUnitDim(vv);
      }

      if (!panelType && /panel\s*type/i.test(kk)) {
        panelType = normalizePanelTypeForUnitDim(vv);
      }

      if (!swing && /^swing$/i.test(kk)) {
        swing = normalizeSwingForUnitDim(vv);
      }

      if (!doorType && /door\s*type/i.test(kk)) {
        doorType = normalizeDoorTypeForUnitDim(vv);
      }
    });

    if (!doorType) {
      doorType = normalizeDoorTypeForUnitDim(getTitleTextFromRowForUnitDim(tr, item));
    }

    if (!doorType || !size) {
      return {
        unit_dimension: '',
        rough_opening: '',
        glass_dimension: ''
      };
    }

    const sizeNode =
      map?.hinged?.[doorType]?.[size] ||
      map?.gliding?.[doorType]?.[size] ||
      map?.fixed?.[doorType]?.[size] ||
      map?.transom?.[doorType]?.[size];

    if (!sizeNode) {
      return {
        unit_dimension: '',
        rough_opening: '',
        glass_dimension: ''
      };
    }

    let raw = '';

    if (typeof sizeNode === 'string') {
      raw = sizeNode;
    } else if (panelType && sizeNode[panelType]) {
      const panelNode = sizeNode[panelType];
      raw = panelNode?.[swing || 'all'] != null ? panelNode?.[swing || 'all'] : (panelNode?.all || '');
    } else if (sizeNode[swing || 'all'] != null || sizeNode.all != null) {
      raw = sizeNode[swing || 'all'] != null ? sizeNode[swing || 'all'] : sizeNode.all;
    } else {
      const keys = Object.keys(sizeNode || {});
      if (keys.length === 1) {
        const onlyNode = sizeNode[keys[0]];
        if (typeof onlyNode === 'string') {
          raw = onlyNode;
        } else {
          raw = onlyNode?.[swing || 'all'] != null ? onlyNode?.[swing || 'all'] : (onlyNode?.all || '');
        }
      }
    }

    if (typeof raw === 'string') {
      return {
        unit_dimension: raw,
        rough_opening: '',
        glass_dimension: ''
      };
    }

    if (raw && typeof raw === 'object') {
      return {
        unit_dimension: raw.unit_dimension || '',
        rough_opening: raw.rough_opening || '',
        glass_dimension: raw.glass_dimension || ''
      };
    }

    return {
      unit_dimension: '',
      rough_opening: '',
      glass_dimension: ''
    };
  } catch (e) {
    console.warn('[ND XLSX] unit-dim parse failed', e);
    return {
      unit_dimension: '',
      rough_opening: '',
      glass_dimension: ''
    };
  }
}

  // ★ XLSX / PDF 共用 disclaimer 文案
  const DISCLAIMER_TEXT =
    'Please Note : If there is any discrepancy between the configurator price and Neuma Doors Price Guide, Neuma Doors inside sales department will inform you and provide the price based on the price guide.';

  const readJson = (id, fallback) => {
    try {
      const el = document.getElementById(id);
      return el ? (JSON.parse(el.textContent || 'null') ?? fallback) : fallback;
    } catch (_) { return fallback; }
  };
  const TAGS = readJson('cx2-tags-json', []) || [];
  const CUST = readJson('cx2-customer-json', null);
  const customerEmail = (CUST?.email || 'guest').toLowerCase();
  const fallbackPrefix = () => {
    const hit = (TAGS || []).find(x => /^[A-Za-z]{6}$/.test(String(x || '').trim()));
    return hit ? String(hit).toUpperCase() : 'SN';
  };
  const custKey = () => (CUST && (CUST.id || CUST.email)) ? String(CUST.id || CUST.email) : 'anon';

  // ---- ND xlsx export: hide internal properties (uuid/_bss/_nd/etc) ----
function __ndNormalizeKey(k){
  return String(k || '').trim().toLowerCase();
}
function __ndShouldSkipExportPropKey(k){
  var kk = __ndNormalizeKey(k);
  if (kk === 'uuid') return true;
  if (kk.indexOf('_bss') === 0) return true;
  if (kk.indexOf('_nd') === 0) return true;
  if (kk.indexOf('nd:') === 0) return true;
  if (kk.indexOf('nd_') === 0) return true;
  if (kk.indexOf('nd_reload') !== -1) return true;
  return false;
}

function __ndShouldSkipDisplayOptionName(k){
  const kk = String(k || '')
    .trim()
    .toLowerCase()
    .replace(/[\s_#:-]+/g, '');

  return [
    'referencenumber',
    'reference',
    'referencenumb',
    'factor'
  ].includes(kk);
}

function __ndFilterPropsForExport(props){
  var out = {};
  try{
    props = props || {};
    Object.keys(props).forEach(function(k){
      if (__ndShouldSkipExportPropKey(k)) return;
      out[k] = props[k];
    });
  }catch(e){}
  return out;
}

  // ★ 跟 PDF 相同：優先使用 GAS 回傳的正式 quotation_no
  function getOfficialQuoteNo() {
    try {
      if (window.ND_QUOTE_SERIAL_FULL) {
        const q1 = String(window.ND_QUOTE_SERIAL_FULL).trim().toUpperCase();
        if (/^[A-Z0-9]{6}-\d{5}$/.test(q1)) return q1;
      }
      const info = window.ND_LAST_FINAL_QUOTE || window.ND_QUOTE_FINAL_INFO || null;
      if (!info || !info.quotation_no) return null;
      const q = String(info.quotation_no).trim().toUpperCase();
      if (!/^[A-Z0-9]{6}-\d{5}$/.test(q)) return null;
      return q;
    } catch (e) {
      return null;
    }
  }

  function getSerialAndMarkXlsx() {
    if (window.cartExportUnified?.getSerial && window.cartExportUnified?.markXlsxDone) {
      const s = window.cartExportUnified.getSerial();
      window.cartExportUnified.markXlsxDone();
      return s;
    }
    const prefix = fallbackPrefix(); const key = `ND:SERIAL2:${custKey()}:${prefix}`;
    let st = null; try { st = JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { }
    if (!st || st.prefix !== prefix) st = { n: 1, pdf: false, xlsx: false, prefix };
    const serial = `${prefix}-${String(st.n).padStart(4, '0')}`;
    st.xlsx = true; if (st.pdf && st.xlsx) { st.n++; st.pdf = st.xlsx = false; }
    localStorage.setItem(key, JSON.stringify(st));
    return serial;
  }

  /* ---------------- ExcelJS & cart ---------------- */
  async function ensureExcelJS() {
    if (window.ExcelJS) return window.ExcelJS;
    await new Promise((res, rej) => {
      const s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/exceljs/dist/exceljs.min.js';
      s.onload = res;
      s.onerror = () => rej(new Error('ExcelJS 載入失敗'));
      document.head.appendChild(s);
    });
    return window.ExcelJS;
  }
  async function fetchCart() {
    const r = await fetch('/cart.js?_=' + Date.now(), {
      credentials: 'include',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
    });
    if (!r.ok) throw new Error('無法讀取購物車');
    return r.json();
  }

  /* ---------------- Price helpers ---------------- */
  const FACTOR_KEY = 'cart_discount_factor_v1';
  function sanitizeDecimal(str) {
    str = String(str || '').replace(/[^0-9.]/g, '');
    const parts = str.split('.');
    if (parts.length > 2) str = parts.shift() + '.' + parts.join('');
    if (str.startsWith('.')) str = '0' + str;
    return str;
  }
  function readLiveFactor() {
    const el = document.querySelector('#nd-factor-input,[name="nd-factor"],input[data-nd-factor],input[name="attributes[factor]"]');
    if (el && typeof el.value === 'string') {
      const raw = sanitizeDecimal(el.value);
      if (raw === '') { try { localStorage.removeItem(FACTOR_KEY); } catch (_) { } return 1.000; }
      const n = parseFloat(raw);
      return Number.isFinite(n) ? clamp3(n) : 1.000;
    }
    const ls = parseFloat(localStorage.getItem(FACTOR_KEY));
    return Number.isFinite(ls) ? clamp3(ls) : 1.000;
  }
  const clamp3 = n => Number(Math.max(0, Math.min(9.999, Number(n))).toFixed(3));

  /* ---------------- DOM helpers ---------------- */
  const itemRowsInDom = () => Array.from(document.querySelectorAll('#main-cart-items tbody tr.cart-item'));
  function readDomOptionPairs(itemEl) {
  const out = [];
  itemEl?.querySelectorAll('.product-option')?.forEach(node => {
    const k = node.querySelector('dt')?.textContent?.replace(/:\s*$/, '').trim() || '';
    const v = node.querySelector('dd')?.textContent?.trim() || '';
    if (!k) return;

    const kk = String(k).trim().toLowerCase();

    // ✅ skip internal keys
    if (kk === 'uuid') return;
    if (kk.startsWith('_')) return;
    if (/^_+bss/i.test(k)) return;
    if (__ndShouldSkipExportPropKey(k)) return;
    if (__ndShouldSkipDisplayOptionName(k)) return;

    out.push([k, v]);
  });
  return out;
}
function readDimensionBlockFromCartRow(tr) {
  try {
    if (!tr) {
      return { unitDim: '', roughOpening: '', glassDimension: '' };
    }

    function pickFromText(text, label) {
      const re = new RegExp(label + '\\s*:\\s*([^\\n\\r]+)', 'i');
      const m = String(text || '').match(re);
      return m ? String(m[1] || '').trim() : '';
    }

    function extract(text) {
      const raw = String(text || '');
      return {
        unitDim: pickFromText(raw, 'Unit\\s*Dim\\.?'),
        roughOpening: pickFromText(raw, 'Rough\\s*Opening'),
        glassDimension: pickFromText(raw, 'Glass\\s*Dimension')
      };
    }

    function hasAny(v) {
      return !!(v.unitDim || v.roughOpening || v.glassDimension);
    }

    // 1) 先抓自己
    let found = extract(tr.innerText || tr.textContent || '');
    if (hasAny(found)) return found;

    // 2) 抓最近的 cart item 外層容器
    const wrappers = [
      tr.closest('.cart-item'),
      tr.closest('tr'),
      tr.closest('tbody'),
      tr.closest('#main-cart-items'),
      tr.parentElement,
      tr.parentElement?.parentElement
    ].filter(Boolean);

    for (const el of wrappers) {
      found = extract(el.innerText || el.textContent || '');
      if (hasAny(found)) return found;
    }

    // 3) 抓同一個品項周圍常見右側區塊
    const nearbySelectors = [
      '.nd-unit-dimension-wrap',
      '.nd-unit-dimension-block',
      '.unit-dimension-block',
      '.unit-dim-block',
      '.cart-item__details',
      '.cart-item__media',
      '.cart-item__right',
      '.cart-item__image-wrapper',
      '.cart-item__totals',
      '.product-option',
      '[data-unit-dimension]',
      '[data-dimension-block]'
    ];

    for (const root of wrappers) {
      for (const sel of nearbySelectors) {
        const nodes = root.querySelectorAll ? Array.from(root.querySelectorAll(sel)) : [];
        for (const node of nodes) {
          found = extract(node.innerText || node.textContent || '');
          if (hasAny(found)) return found;
        }
      }
    }

    // 4) 最後抓整個 main cart 區塊
    const mainCart = document.querySelector('#main-cart-items');
    if (mainCart) {
      found = extract(mainCart.innerText || mainCart.textContent || '');
      if (hasAny(found)) return found;
    }

    return { unitDim: '', roughOpening: '', glassDimension: '' };
  } catch (e) {
    console.warn('[ND XLSX] readDimensionBlockFromCartRow failed', e);
    return { unitDim: '', roughOpening: '', glassDimension: '' };
  }
}
function readDimensionBlockByIndex(idx) {
  try {
    const text = document.body?.innerText || document.body?.textContent || '';
    if (!text) return { unitDim: '', roughOpening: '', glassDimension: '' };

    const pattern = /Unit\s*Dim\.?\s*:\s*([^\n\r]+)[\s\S]*?Rough\s*Opening\s*:\s*([^\n\r]+)[\s\S]*?Glass\s*Dimension\s*:\s*([^\n\r]+)/gi;
    const matches = [];
    let m;

    while ((m = pattern.exec(text)) !== null) {
      matches.push({
        unitDim: String(m[1] || '').trim(),
        roughOpening: String(m[2] || '').trim(),
        glassDimension: String(m[3] || '').trim()
      });
    }

    return matches[idx] || { unitDim: '', roughOpening: '', glassDimension: '' };
  } catch (e) {
    console.warn('[ND XLSX] readDimensionBlockByIndex failed', e);
    return { unitDim: '', roughOpening: '', glassDimension: '' };
  }
}

  // ★ 只讀上方 Reference Number input，不再混用 note
  function readReferenceFromDOM() {
    const sels = [
      'input[name="attributes[Reference Number]"]',
      'input[name="attributes[reference_number]"]',
      '#Cart-reference-number',
      'input#Cart-reference-number',
      '[data-ref-number]'
    ];
    for (const s of sels) {
      const el = document.querySelector(s);
      if (el && typeof el.value === 'string') {
        const v = el.value.trim();
        if (v) return v;
      }
    }
    return '';
  }

function normalizePanelTypeForUnitDim(raw) {
  const text = String(raw || '').toLowerCase().trim();
  if (/3\s*\/\s*4\s*lite|3\/4\s*lite|3\s*4\s*lite|three\s*quarter\s*lite/.test(text)) {
    return 'three_quarter_lite';
  }
  if (/full\s*view|full\s*lite/.test(text)) {
    return 'full_lite';
  }
  return '';
}

function normalizeDoorSizeForUnitDim(raw) {
  const m = String(raw || '').match(/\b\d{4,6}\b/);
  return m ? m[0] : '';
}

function normalizeSwingForUnitDim(raw) {
  const text = String(raw || '').toLowerCase().trim();
  if (/out\s*swing|outswing/.test(text)) return 'outswing';
  if (/in\s*swing|inswing/.test(text)) return 'inswing';
  return 'all';
}

function normalizeDoorTypeForUnitDim(raw) {
  const text = String(raw || '').toLowerCase().trim();

  if (/single[\s_-]*hinged/.test(text)) return 'single_hinged';
  if (/double[\s_-]*hinged/.test(text)) return 'double_hinged';
  if (/center[\s_-]*hinged.*2\s*panels?|center[\s_-]*hinged.*2\s*panel/.test(text)) return 'center_hinged_2_panel';
  if (/center[\s_-]*hinged.*3\s*panels?|center[\s_-]*hinged.*3\s*panel/.test(text)) return 'center_hinged_3_panel';

  if (/bypass\s*gliding/.test(text)) return 'bypass_gliding';
  if (/gliding\s*door.*2\s*panels?|gliding.*2\s*panel/.test(text)) return 'gliding_2_panel';
  if (/gliding\s*door.*3\s*panels?|gliding.*3\s*panel/.test(text)) return 'gliding_3_panel';
  if (/gliding\s*door.*4\s*panels?|gliding.*4\s*panel/.test(text)) return 'gliding_4_panel';

  if (/fixed\s*\(?\s*gliding\s*\)?\s*-\s*1\s*panel/.test(text)) return 'gliding_one_panel';
  if (/fixed\s*-\s*1\s*panel/.test(text)) return 'hinged_one_panel';
  if (/fixed\s*-\s*2\s*panels?/.test(text)) return 'hinged_two_panel';
  if (/fixed\s*-\s*3\s*panels?/.test(text)) return 'hinged_three_panel';

  if (/transom\s*-\s*1\s*lite/.test(text)) return 'transom_1_lite';
  if (/transom\s*-\s*2\s*lite/.test(text)) return 'transom_2_lite';
  if (/transom\s*-\s*3\s*lite/.test(text)) return 'transom_3_lite';
  if (/transom\s*-\s*4\s*lite/.test(text)) return 'transom_4_lite';

  return '';
}

function getTitleTextFromRowForUnitDim(tr, item) {
  if (tr) {
    const t =
      tr.querySelector('.cart-item__name')?.textContent ||
      tr.querySelector('.cart-item__details a')?.textContent ||
      tr.querySelector('.cart-item__details')?.textContent ||
      '';
    if (String(t || '').trim()) return String(t).trim();
  }
  return String(item?.product_title || item?.title || '').trim();
}
  // ★ 下方 Special Instruction / note
  function readSpecialInstructionFromDOM() {
    const sels = [
      '#Cart-note',
      'textarea#Cart-note',
      'textarea[name="note"]',
      'textarea[name="attributes[Special Instruction]"]',
      'textarea[name="attributes[special_instruction]"]',
      '[data-special-instruction]'
    ];
    for (const s of sels) {
      const el = document.querySelector(s);
      if (el && typeof el.value === 'string') {
        const v = el.value.trim();
        if (v) return v;
      }
    }
    return '';
  }

  // ★ 上方 Shipping block：Contact / Phone / Company / Address
  function readShippingInfoFromDOM() {
    function val(selectors) {
      for (const sel of selectors) {
        const el = document.querySelector(sel);
        if (el && typeof el.value === 'string') {
          const v = el.value.trim();
          if (v) return v;
        }
      }
      return '';
    }
    const contact = val([
      'input[name="attributes[Shipping Contact Name]"]',
      'input[name="attributes[Contact Name]"]',
      'input[name="attributes[contact_name]"]',
      '[data-nd-contact]'
    ]);
    const phone = val([
      'input[name="attributes[Shipping Phone]"]',
      'input[name="attributes[Phone Number]"]',
      'input[name="attributes[phone_number]"]',
      '[data-nd-phone]'
    ]);
    const company = val([
      'input[name="attributes[Company Name]"]',
      '[data-nd-company]'
    ]);
    const address = val([
      'textarea[name="attributes[Shipping Address]"]',
      'textarea[name="attributes[shipping_address]"]',
      '[data-nd-shipaddr]'
    ]);
    return { contact, phone, company, address };
  }

  // ★ attrs + DOM 混合，key 做模糊比對
  function pickAttr(attrs, domVal, candidates) {
    if (domVal && String(domVal).trim()) return String(domVal).trim();
    const normKey = k => String(k || '').toLowerCase().replace(/[\s_]+/g, '');
    const wants = (candidates || []).map(normKey);
    const keys = Object.keys(attrs || {});
    for (const k of keys) {
      const nk = normKey(k);
      if (wants.includes(nk)) {
        const v = attrs[k];
        if (typeof v === 'string' && v.trim()) return v.trim();
      }
    }
    return '';
  }

  /* ---------------- Images (load/measure) ---------------- */
  const normalizeWxH = t => {
    const ns = String(t || '').match(/\d+/g);
    return (ns && ns.length >= 2) ? `${ns[0]}x${ns[1]}` : '';
  };
  function shopifyFileUrl(basename) {
    if (!basename) return null;
    if (/^https?:\/\//i.test(basename)) return basename;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return [`${root}files/${basename}.webp`, `${root}files/${basename}.png`, `${root}files/${basename}.jpg`];
  }
  async function fallbackImageUrlList(it, domPairs) {
    const dict = {};
    (it?.options_with_values || []).forEach(o => { if (o?.name) dict[o.name] = String(o.value || ''); });
    (domPairs || []).forEach(([k, v]) => { if (k) dict[String(k).trim()] = String(v || '').trim(); });
    const grid = dict['Grid Pattern'] || ''; const style = dict['Grid Pattern Style'] || '';
    const c = []; const wxh = normalizeWxH(grid) || '2x3';
    if (/Equal\s*Lite/i.test(style)) c.push(shopifyFileUrl(`${wxh}_equal_lite`));
    if (/4\s*Lite\s*Tall/i.test(style)) c.push(shopifyFileUrl(`${wxh}_4_lite_tall`));
    if (/9\s*Lite\s*Prairie/i.test(style)) c.push(shopifyFileUrl(`${wxh}_9_lite_prairie`));
    if (/Special\s*Pattern/i.test(style)) c.push(shopifyFileUrl(`need_drawing`));
    const direct = it?.image || it?.featured_image?.url || it?.featured_image?.src;
    if (direct) c.push(direct);
    const key = /(need_drawing|_equal_lite|_4_lite_tall|_9_lite_prairie)/i;
    const arr = (c.flat ? c.flat() : c).filter(Boolean);
    arr.sort((u, v) => (key.test(v) ? 1 : 0) - (key.test(u) ? 1 : 0));
    return arr;
  }

  function measureDataUrl(dataUrl) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve({ w: img.naturalWidth || img.width || 1, h: img.naturalHeight || img.height || 1 });
      img.onerror = () => resolve({ w: 1, h: 1 });
      img.src = dataUrl.startsWith('data:') ? dataUrl : ('data:image/png;base64,' + dataUrl);
    });
  }
  const IMG_CACHE = new Map();
  async function urlToPNGBase64(u, ND) {
    if (IMG_CACHE.has(u)) return IMG_CACHE.get(u);
    let b64 = null;
    if (ND && ND.urlToBase64PNG) b64 = await ND.urlToBase64PNG(u, 420);
    if (!b64 && ND && ND.urlListToDataUrl) {
      const du = await ND.urlListToDataUrl([u], 420);
      if (du && du.indexOf(',') > 0) b64 = du.split(',')[1];
    }
    if (b64) IMG_CACHE.set(u, b64);
    return b64;
  }

  const isTransomUrl = (u) => /(?:^|\/)DGT-[A-Za-z0-9_-]+/i.test(String(u || ''));
  const isP3Url = (u) => /(?:^|\/)D[A-Za-z0-9]{2}-[A-Za-z0-9]{3}(?:[^A-Za-z0-9]|$)/i.test(String(u || ''));
  const isP4Url = (u) => /(?:^|\/)D[A-Za-z0-9]{2}-[A-Za-z0-9]{4}(?:[^A-Za-z0-9]|$)/i.test(String(u || ''));

  function drawSize(meta, flags) {
    const MAX_W_LAND = 100, MAX_H_LAND = 74;
    const MAX_W_PORT = 74, MAX_H_PORT = 100;
    const TRANSOM_W_BONUS = 28, TRANSOM_H_BONUS = 8;
    const P3_W_BONUS = 18, P3_H_BONUS = 0;
    const P4_W_BONUS = 26, P4_H_BONUS = 0;

    const land = (meta.w || 1) >= (meta.h || 1);
    let maxW = land ? MAX_W_LAND : MAX_W_PORT;
    let maxH = land ? MAX_H_LAND : MAX_H_PORT;
    if (flags?.transom) { maxW += TRANSOM_W_BONUS; maxH += TRANSOM_H_BONUS; }
    if (flags?.p3) { maxW += P3_W_BONUS; maxH += P3_H_BONUS; }
    if (flags?.p4) { maxW += P4_W_BONUS; maxH += P4_H_BONUS; }
    const s = Math.min(maxW / Math.max(1, meta.w), maxH / Math.max(1, meta.h));
    return { w: Math.max(8, Math.round(meta.w * s)), h: Math.max(8, Math.round(meta.h * s)) };
  }

  /* ---------------- EMU/row helpers ---------------- */
  const PX = (n) => Math.round((n || 0) * 9525);
  const PX_PER_PT = 96 / 72;
  const DEFAULT_ROW_PX = Math.round(15 * PX_PER_PT); // 15pt ≈ 20px
  const rowTopPx = (rowNo) => (rowNo - 1) * DEFAULT_ROW_PX;
  function yToRowAndOff(yPx) {
    const rowIndex = Math.floor(yPx / DEFAULT_ROW_PX) + 1;
    const offPx = Math.max(0, Math.round(yPx - (rowIndex - 1) * DEFAULT_ROW_PX));
    return { rowIndex, offPx };
  }

  /* ---------------- B 欄圖片區設定 ---------------- */
  const IMG_ZONE_COL_START = 2;   // B 欄
  const LEFT_GUARD_PX = 8;
  const RIGHT_GUARD_PX = 8;
  const IMG_ALIGN = 'center';
  const CENTER_NUDGE_PX = 8;
  const RIGHT_BIAS_PX = 12;

  const TOP_PAD_PX = 2;
  const SECOND_GAP_PX = 12;
  const START_AFTER_DOOR_SIZE_ROWS_MIN = 2;
  const START_AFTER_DOOR_SIZE_ROWS_MAX = 3;
  const TRANSOM_DOWN_PX = 8;

  /* ---------------- Borders ---------------- */
  function setRowBorderAll(ws, rowNo, style = 'thin') {
    for (let c = 1; c <= 8; c++) {
      ws.getRow(rowNo).getCell(c).border = {
        top: { style }, left: { style }, bottom: { style }, right: { style }
      };
    }
  }
  function setRowBorderVerticalOnly(ws, rowNo, style = 'thin') {
    for (let c = 1; c <= 8; c++) {
      ws.getRow(rowNo).getCell(c).border = { left: { style }, right: { style } };
    }
  }
  function setRowBorderVerticalWithBottom(ws, rowNo, style = 'thin') {
    for (let c = 1; c <= 8; c++) {
      ws.getRow(rowNo).getCell(c).border = {
        left: { style }, right: { style }, bottom: { style }
      };
    }
  }

  /* ---------------- Builder ---------------- */
  async function ensureAndBuild(cart, serial, referenceText, shippingPairs, specialRaw) {
  const ExcelJS = await ensureExcelJS();
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Cart');

  const exportBrandWithLogo = window.ND_getExportBrandWithLogoData
    ? await window.ND_getExportBrandWithLogoData()
    : null;

  const BRAND_LOGO_DATA_URL = exportBrandWithLogo?.logoDataUrl || '';

    ws.columns = [
      { key: 'line', width: 6 }, { key: 'prod', width: 38 }, { key: 'qty', width: 10 },
      { key: 'oname', width: 22 }, { key: 'oval', width: 28 }, { key: 'add', width: 14 },
      { key: 'unit', width: 14 }, { key: 'linep', width: 14 }
    ];

    ws.mergeCells('A1:C1');

if (BRAND_LOGO_DATA_URL) {
  // 有 logo：放 logo，不顯示 Neuma Doors
  ws.getCell('A1').value = '';
  ws.getRow(1).height = 30;
  ws.getRow(2).height = 20;
  ws.getRow(3).height = 20;

  try {
    const logoImageId = wb.addImage({
      base64: BRAND_LOGO_DATA_URL,
      extension: 'png'
    });

    // 左上角 A1~C3 區域放 logo
    ws.addImage(logoImageId, {
      tl: { col: 0.5, row: 1.5 },
      ext: { width: 180, height: 60 },
      editAs: 'oneCell'
    });
  } catch (e) {
    console.warn('[ND XLSX] brand logo draw failed', e);

    // 失敗就退回原本樣式
    ws.getCell('A1').value = COMPANY;
    ws.getCell('A1').font = { bold: true, size: 16 };
    ws.getRow(1).height = 25;
  }
} else {
  // 沒 logo：維持原本設計
  ws.getCell('A1').value = COMPANY;
  ws.getCell('A1').font = { bold: true, size: 16 };
  ws.getRow(1).height = 25;
}

    ws.addRow(['', '', '', '', '', 'Quotation # :', serial, '']);
    ws.addRow(['', '', '', '', '', 'Date :', fmtMDY(), '']);
    const rRef = ws.addRow(['', '', '', '', '', 'Reference # :', referenceText || '', '']);
    rRef.getCell(7).alignment = { wrapText: true, vertical: 'top' };

    if (shippingPairs && shippingPairs.length) {
      const rShip = ws.addRow(['Ship To :', '', '', '', '', '', '', '']);
      rShip.getCell(1).font = { bold: true };
      shippingPairs.forEach(([label, val]) => {
        const row = ws.addRow([label, val, '', '', '', '', '', '']);
        row.getCell(1).font = { bold: true };
        row.getCell(2).alignment = { wrapText: true, vertical: 'top' };
      });
      ws.addRow([]);
    } else {
      ws.addRow([]);
    }

    let maxLabelLen = 'Line'.length;
    if (shippingPairs && shippingPairs.length) {
      shippingPairs.forEach(([label]) => {
        if (label) maxLabelLen = Math.max(maxLabelLen, String(label).length);
      });
      maxLabelLen = Math.max(maxLabelLen, 'Ship To :'.length);
    }
    if (specialRaw) {
      maxLabelLen = Math.max(maxLabelLen, 'Special Instruction :'.length);
    }
    const col1 = ws.getColumn(1);
    const origWidth = col1.width || 6;
    if (maxLabelLen > 0) {
      col1.width = Math.max(origWidth, maxLabelLen + 2);
    }

    const headerRow = ws.addRow([
      'Line', 'Product', 'Quantity', 'Option Name', 'Option Value',
      'Add-on Price', 'Unit price', 'Line price'
    ]);
    headerRow.font = { bold: true };
    setRowBorderAll(ws, headerRow.number, 'thin');

    const FACTOR =
      (typeof window.__ND_FACTOR_EFFECTIVE__ === 'number')
        ? window.__ND_FACTOR_EFFECTIVE__
        : readLiveFactor();
if (!window.ND_EXPORT_SSOT || typeof window.ND_EXPORT_SSOT.calc !== 'function') {
  throw new Error('ND_EXPORT_SSOT engine not loaded');
}

    // Add-on 仍用美元（顯示用），維持你原本的作法
    const adjDollar = d => Math.round(Number(d || 0) * 100 * FACTOR) / 100;

    const domRows = itemRowsInDom();
    const ND = window.NDIMG || null;

    function colWidthToPx(col) {
      const wChar = ws.getColumn(col).width ?? 8.43;
      return Math.floor(wChar * 7 + 5);
    }
    const B_COL_PX = colWidthToPx(IMG_ZONE_COL_START);

    function fitWidthToB(w, h) {
      const maxW = Math.max(8, B_COL_PX - (LEFT_GUARD_PX + RIGHT_GUARD_PX));
      if (w <= maxW) return { w, h };
      const s = maxW / Math.max(1, w);
      return { w: Math.round(w * s), h: Math.round(h * s) };
    }
    function floatColForXPx(xPx) {
      const leftEdge = LEFT_GUARD_PX;
      const rightEdge = Math.max(leftEdge, B_COL_PX - RIGHT_GUARD_PX - RIGHT_BIAS_PX);
      let x = Math.min(rightEdge, Math.max(leftEdge, xPx));
      if (IMG_ALIGN === 'right') x = rightEdge;
      else if (IMG_ALIGN === 'left') x = leftEdge;
      const colFloat = (IMG_ZONE_COL_START - 1) + (x / B_COL_PX);
      return { col: colFloat, colOff: 0 };
    }

    // ★ NEW：用來做 Estimated total 的 per-unit 加總
    let estimatedAfter = 0;

    for (let idx = 0; idx < (cart.items || []).length; idx++) {
      const it = cart.items[idx];
      const lineNo = idx + 1, qty = Number(it.quantity || 0);

      // ★ per-unit rounding（關鍵）
      // ★ SSOT pricing (per-option rounding, single source of truth)
// ★ SSOT pricing (DOM-based, per-option rounding, single source of truth)
const domRow = (domRows && domRows[idx]) ? domRows[idx] : null;
const ssotOptions = [];
const domPairsForNoGlass = domRow ? readDomOptionPairs(domRow) : [];

if (domRow) {
  domRow.querySelectorAll('.product-option').forEach(node => {
    const name = node.querySelector('dt')?.textContent?.replace(/:\s*$/, '').trim();
    const rawVal = node.querySelector('dd')?.textContent?.trim();
    if (!name || !rawVal) return;

    const nk = String(name).toLowerCase();
if (nk === 'uuid' || nk.startsWith('_')) return;
if (__ndShouldSkipExportPropKey(name)) return;
if (__ndShouldSkipDisplayOptionName(name)) return;

    const __parseAddon = (raw) => {
      if (!raw) return { clean: '', add: 0 };
      let s = String(raw).trim(), m, total = 0;
      const re = /\(\s*\+\s*\$?\s*([0-9,]+(?:\.\d{1,2})?)\s*\)/g;
      while ((m = re.exec(s)) !== null) {
        total += parseFloat(m[1].replace(/,/g, '')) || 0;
      }
      s = s.replace(re, '').replace(/\s{2,}/g, ' ').trim();
      return { clean: s, add: total };
    };

    const p = __parseAddon(rawVal);
    if (!p.add) return;

    ssotOptions.push({
      name,
      value: p.clean,
      rawCents: Math.round(p.add * 100)
    });
  });
}
// ★ Unit Dim. 當成純文字 option 丟進 SSOT
let dimBlock = readDimensionBlockFromCartRow(domRow);

if (!dimBlock.unitDim && !dimBlock.roughOpening && !dimBlock.glassDimension) {
  dimBlock = readDimensionBlockByIndex(idx);
}

console.log('[ND XLSX][DIM BLOCK]', idx, dimBlock);
const unitDim = dimBlock.unitDim || '';
const roughOpening = dimBlock.roughOpening || '';
const glassDimension = dimBlock.glassDimension || '';


if (unitDim) {
  ssotOptions.push({
    name: 'Unit Dim.',
    value: unitDim,
    rawCents: 0
  });
}

if (roughOpening) {
  ssotOptions.push({
    name: 'Rough Opening',
    value: roughOpening,
    rawCents: 0
  });
}

if (glassDimension) {
  ssotOptions.push({
    name: 'Glass Dimension',
    value: glassDimension,
    rawCents: 0
  });
}
// ★ No Glass deduction 當成負數 option 丟進 SSOT
const noGlassDeductionCents = getNoGlassDeductionCentsFromPairs(domPairsForNoGlass, domRow);
if (noGlassDeductionCents > 0) {
  ssotOptions.push({
    name: 'No Glass Credit',
    value: 'Deduction',
    rawCents: -noGlassDeductionCents
  });
}

const ssot = window.ND_EXPORT_SSOT.calc({
  options: ssotOptions,
  factor: FACTOR,
  qty
});

estimatedAfter += ssot.lineCents;

const unit = `$${money(ssot.unitCents)}`;
const line = `$${money(ssot.lineCents)}`;

      const rMain = ws.addRow([lineNo, String(it.product_title || it.title || ''), qty, '', '', '', unit, line]);
      rMain.font = { bold: true };
      ws.getCell(rMain.number, 2).alignment = { vertical: 'top', wrapText: true };
      setRowBorderAll(ws, rMain.number, 'thin');

      // 收圖
      let picks = [];
      try {
        const domPairs = (domRows.length && domRows[idx]) ? readDomOptionPairs(domRows[idx]) : [];
        const urlList = ND && ND.getItemImageUrls
          ? ND.getItemImageUrls(it, domPairs, domRows[idx])
          : await fallbackImageUrlList(it, domPairs);
        const uniq = Array.from(new Set((urlList || []).filter(Boolean)));
        for (const u of uniq) {
          if (picks.length >= 2) break;
          const b64 = await urlToPNGBase64(u, ND);
          if (!b64) continue;
          const base64 = b64.startsWith('data:') ? b64 : ('data:image/png;base64,' + b64);
          const meta = await measureDataUrl(base64);
          picks.push({
            base64, meta, url: u,
            transom: isTransomUrl(u), p3: isP3Url(u), p4: isP4Url(u),
            special: /(need_drawing|_equal_lite|_4_lite_tall|_9_lite_prairie)/i.test(String(u))
          });
        }
      } catch (_) { }

      // 細項列（★只修剪 Name；Value 完整保留）
      const seen = new Set();
      let doorSizeRowNo = null;
      let lastDetailRowNo = rMain.number;
      const pushOptionRow = (name, val) => {
  if (norm(name) === 'title') return;
  if (norm(val) === 'default title') return;

  const n0 = String(name || '').trim().toLowerCase();
  if (n0 === 'uuid') return;
  if (__ndShouldSkipExportPropKey(name)) return;
  if (__ndShouldSkipDisplayOptionName(name)) return;

  const p = parseAddon(val);
  const nameTrim = trimDash(String(name || ''));
  const valKeep = trimUuidTail((p.clean || String(val || '')).trim());

        const k = norm(nameTrim) + '|' + norm(valKeep);
        if (seen.has(k)) return;
        seen.add(k);

        const add = p.add ? `$${formatDollar(adjDollar(p.add))}` : '';

        const row = ws.addRow(['', '', '', nameTrim, valKeep, add, '', '']);
        setRowBorderVerticalOnly(ws, row.number, 'thin');
        lastDetailRowNo = row.number;

        if (!doorSizeRowNo && /door\s*size/i.test(String(nameTrim))) doorSizeRowNo = row.number;
      };

      (it.options_with_values || []).forEach(o => { if (o) pushOptionRow(o.name || '', o.value || ''); });
      try {
        if (domRows.length && domRows[idx]) {
          readDomOptionPairs(domRows[idx]).forEach(p => pushOptionRow(p[0], p[1]));
        }
      } catch (_) { }
            // ✅ Filter internal props before exporting (uuid/_bss/_nd/...)
      const rawProps = it.properties || {};
      const props = (Array.isArray(rawProps) ? rawProps : __ndFilterPropsForExport(rawProps));

            if (Array.isArray(props) && props.length) {
        props.forEach(p => {
          const k = p?.name ?? p?.key ?? p?.first;
          const v = p?.value ?? p?.val ?? p?.last;
          if (!k || v == null || v === '') return;
          if (String(k).startsWith('_') || /^_+bss/i.test(String(k))) return;
          if (__ndShouldSkipExportPropKey(k)) return; // ✅ extra guard
          pushOptionRow(k, String(v));
        });
      } else if (typeof props === 'object' && Object.keys(props).length) {
        Object.keys(props).forEach(k => {
          const v = props[k];
          if (!k || v == null || v === '') return;
          if (String(k).startsWith('_') || /^_+bss/i.test(String(k))) return;
          if (__ndShouldSkipExportPropKey(k)) return; // ✅ key blacklist
          pushOptionRow(k, String(v));
        });
      }

      if (unitDim) {
        pushOptionRow('Unit Dim.', unitDim);
      }

      if (roughOpening) {
        pushOptionRow('Rough Opening', roughOpening);
      }

      if (glassDimension) {
        pushOptionRow('Glass Dimension', glassDimension);
      }

if (noGlassDeductionCents > 0) {
  const noGlassDisplay = Math.round(noGlassDeductionCents * FACTOR) / 100;

  const row = ws.addRow([
    '', '', '',
    'No Glass Credit',
    'Deduction',
    `-$${formatDollar(noGlassDisplay)}`,
    '',
    ''
  ]);

  setRowBorderVerticalOnly(ws, row.number, 'thin');
  lastDetailRowNo = row.number;
}
      if (lastDetailRowNo > 0) setRowBorderVerticalWithBottom(ws, lastDetailRowNo, 'thin');

      // ===== 圖片（B 欄；Door Size 後第 2~3 列起；限制在本品項底線） =====
      if (picks.length) {
        const primary = picks.find(p => !p.special) || picks[0];
        const second = picks.find(p => p !== primary) || null;

        let s1 = drawSize(primary.meta, primary);
        let s2 = second ? drawSize(second.meta, second) : { w: 0, h: 0 };

        s1 = { w: Math.round(s1.w * IMG_GLOBAL_SCALE), h: Math.round(s1.h * IMG_GLOBAL_SCALE) };
        if (second) s2 = { w: Math.round(s2.w * IMG_GLOBAL_SCALE), h: Math.round(s2.h * IMG_GLOBAL_SCALE) };

        s1 = fitWidthToB(s1.w, s1.h);
        if (second) s2 = fitWidthToB(s2.w, s2.h);

        const baseRow = doorSizeRowNo ? doorSizeRowNo : (rMain.number + 1);
        const tryRow = baseRow + START_AFTER_DOOR_SIZE_ROWS_MIN;
        const altRow = baseRow + START_AFTER_DOOR_SIZE_ROWS_MAX;

        let yStart = rowTopPx(tryRow) + TOP_PAD_PX + (primary.transom ? TRANSOM_DOWN_PX : 0);
        const areaBottom = rowTopPx(lastDetailRowNo) + DEFAULT_ROW_PX - 2;

        const needH0 = s1.h + (second ? (SECOND_GAP_PX + s2.h) : 0);
        const usableH0 = areaBottom - yStart - 6;
        if (needH0 > usableH0) {
          const y2 = rowTopPx(altRow) + TOP_PAD_PX + (primary.transom ? TRANSOM_DOWN_PX : 0);
          const usableH1 = areaBottom - y2 - 6;
          if (usableH1 > usableH0) yStart = y2;
        }
        let needH = s1.h + (second ? (SECOND_GAP_PX + s2.h) : 0);
        let usableH = Math.max(24, areaBottom - yStart - 6);
        if (needH > usableH) {
          const k = usableH / needH;
          s1 = { w: Math.round(s1.w * k), h: Math.round(s1.h * k) };
          if (second) s2 = { w: Math.round(s2.w * k), h: Math.round(s2.h * k) };
        }

        const centerXPx = Math.round((B_COL_PX - s1.w) / 2 + CENTER_NUDGE_PX);
        const xMain =
          (IMG_ALIGN === 'center')
            ? centerXPx
            : (IMG_ALIGN === 'right'
              ? (B_COL_PX - RIGHT_GUARD_PX - RIGHT_BIAS_PX - s1.w)
              : LEFT_GUARD_PX);

        const x2px = (second)
          ? ((IMG_ALIGN === 'center')
            ? Math.round((B_COL_PX - s2.w) / 2 + CENTER_NUDGE_PX)
            : (IMG_ALIGN === 'right'
              ? (B_COL_PX - RIGHT_GUARD_PX - RIGHT_BIAS_PX - s2.w)
              : LEFT_GUARD_PX))
          : 0;

        let { rowIndex: r1, offPx: off1 } = yToRowAndOff(yStart);
        const id1 = wb.addImage({ base64: primary.base64, extension: 'png' });
        const fCol1 = floatColForXPx(xMain);
        ws.addImage(id1, {
          tl: { col: fCol1.col, row: (r1 - 1) + off1 / DEFAULT_ROW_PX, colOff: 0, rowOff: 0 },
          ext: { width: s1.w, height: s1.h },
          editAs: 'oneCell'
        });

        if (second) {
          let y2 = yStart + s1.h + SECOND_GAP_PX;
          if (y2 + s2.h > areaBottom) y2 = Math.max(yStart, areaBottom - s2.h);
          let { rowIndex: r2, offPx: off2 } = yToRowAndOff(y2);
          const id2 = wb.addImage({ base64: second.base64, extension: 'png' });
          const fCol2 = floatColForXPx(x2px);
          ws.addImage(id2, {
            tl: { col: fCol2.col, row: (r2 - 1) + off2 / DEFAULT_ROW_PX, colOff: 0, rowOff: 0 },
            ext: { width: s2.w, height: s2.h },
            editAs: 'oneCell'
          });
        }
      }
    }

    ws.addRow([]);

    // ★ Estimated total：改成 per-unit rounding 的加總（不再用 items_subtotal_price * factor）
    const totalRow = ws.addRow([
      '', '', '', '', '', '', 'Estimated total',
      `$${money(estimatedAfter)}`
    ]);
    totalRow.font = { bold: true };

    // Special Instruction
    if (specialRaw) {
      ws.addRow([]);
      const rSI = ws.addRow(['Special Instruction :', specialRaw, '', '', '', '', '', '']);
      rSI.getCell(1).font = { bold: true };
      rSI.getCell(2).alignment = { wrapText: true, vertical: 'top' };
    }

    // ★ Disclaimer row（跟 PDF 同一句話，斜體、小一點）
    if (DISCLAIMER_TEXT) {
      ws.addRow([]);
      const rD = ws.addRow(['', DISCLAIMER_TEXT, '', '', '', '', '', '']);
      rD.getCell(2).alignment = { wrapText: true, vertical: 'top' };
      rD.font = { italic: true, size: 9 };
    }

    return wb;
  }

  /* ---------------- Upload ---------------- */
  async function uploadToCloud(fileBlob, filename, subpath, meta = {}) {
    if (!CLOUD_UPLOAD_ENABLED || !fileBlob) return;
    try {
      const fd = new FormData();
      fd.append('file', fileBlob, filename);
      fd.append('path', subpath); fd.append('subpath', subpath);
      fd.append('filename', filename); fd.append('customer', customerEmail);
      if (meta.serial) fd.append('serial', meta.serial);
      if (meta.reference) fd.append('reference', meta.reference);
      const resp = await fetch(CLOUD_ENDPOINT, { method: 'POST', body: fd });
      if (!resp.ok) {
        let hint = '';
        try { const j = await resp.json(); hint = j?.error || j?.hint || ''; } catch { }
        console.warn('[ND-XLSX] cloud upload failed:', resp.status, hint);
      }
    } catch (e) { console.warn('[ND-XLSX] cloud upload error:', e); }
  }

  /* ---------------- Export entry ---------------- */
  let _busy = false;
  async function exportXlsx(btn) {
    if (_busy) return;
    _busy = true;
    if (btn) btn.disabled = true;
    try {
      await new Promise(res => {
        const t0 = Date.now();
        (function loop() {
          if (window.cartExportUnified?.getSerial) return res();
          if (Date.now() - t0 >= 800) return res();
          requestAnimationFrame(loop);
        })();
      });

      const cart = await fetchCart();
      const attrs = cart?.attributes || {};

      const shipDom = readShippingInfoFromDOM();
      const shipContact = pickAttr(attrs, shipDom.contact,
        ['Shipping Contact Name', 'Contact Name', 'contact_name', 'contact']);
      const shipPhone = pickAttr(attrs, shipDom.phone,
        ['Shipping Phone', 'Phone Number', 'phone_number', 'Phone', 'phone']);
      const shipCompany = pickAttr(attrs, shipDom.company,
        ['Company Name', 'company_name', 'Company']);
      const shipAddress = pickAttr(attrs, shipDom.address,
        ['Shipping Address', 'shipping_address', 'Address']);

      const shippingPairs = [];
      if (shipContact) shippingPairs.push(['Contact Name :', shipContact]);
      if (shipCompany) shippingPairs.push(['Company :', shipCompany]);
      if (shipAddress) shippingPairs.push(['Address :', shipAddress]);
      if (shipPhone) shippingPairs.push(['Phone :', shipPhone]);

      const refDom = readReferenceFromDOM();
      const refAttr = pickAttr(attrs, '', ['Reference Number', 'reference_number', 'Reference']);
      const refRaw = (refDom || refAttr || '').trim();
      const refShort = refRaw ? refRaw.slice(0, 120) : '';

      const specialDom = readSpecialInstructionFromDOM();
      const specialJson = (typeof cart.note === 'string') ? cart.note.trim() : '';
      const specialRaw = (specialDom || specialJson || '').trim();

      let serial = getOfficialQuoteNo();
      if (!serial) {
        if (window.cartExportUnified?.getSerial) {
          serial = window.cartExportUnified.getSerial();
        } else {
          serial = getSerialAndMarkXlsx();
        }
      }

      await ensureExcelJS();
      const wb = await ensureAndBuild(cart, serial, refShort, shippingPairs, specialRaw);
      const buf = await wb.xlsx.writeBuffer();
      const blob = new Blob([buf], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `${serial}.xlsx`;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 200);

      const subpath = `${ROOT_FOLDER}/${customerEmail}/${fmtMDY()}`;

if (window.ND_UPLOAD_EMAIL_BRIDGE) {
  window.ND_UPLOAD_EMAIL_BRIDGE.push({
    serial,
    customerEmail,
    customerName: '',
    subpath,
    xlsxBlob: blob,
    xlsxName: `${serial}.xlsx`
  });
} else {
  uploadToCloud(blob, `${serial}.xlsx`, subpath, { serial, reference: refShort });
}

if (window.cartExportUnified?.markXlsxDone) window.cartExportUnified.markXlsxDone();
    } catch (e) {
      console.error('[ND XLSX]', e);
      alert('XLSX 匯出失敗：' + (e?.message || e));
    } finally {
      if (btn) btn.disabled = false;
      _busy = false;
    }
  }
  window.__ND_onClickXlsx = exportXlsx;

  const ID_SEL = ['#download-cart-csv', '#cx2-download-xlsx', '#cx2-download-csv'].join(',');
  document.addEventListener('click', (ev) => {
    const target = ev.target.closest(ID_SEL) || (() => {
      const el = ev.target.closest('button, a, [role="button"]');
      const txt = (el?.textContent || el?.innerText || '').toLowerCase();
      return /(excel|xlsx|csv)/.test(txt) ? el : null;
    })();
    if (!target) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
    exportXlsx(target);
  }, true);
})();
